import { render, staticRenderFns } from "./GFBXCQ.vue?vue&type=template&id=accf11fa&scoped=true"
import script from "./GFBXCQ.vue?vue&type=script&lang=js"
export * from "./GFBXCQ.vue?vue&type=script&lang=js"
import style0 from "./GFBXCQ.vue?vue&type=style&index=0&id=accf11fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accf11fa",
  null
  
)

export default component.exports